export default __webpack_public_path__ + "static/media/boy.51cb6f3b.svg";